import React from 'react'
import { toast } from 'react-toastify'
import { ErrorMessage, InfoMessage, SuccessMessage } from './messages'
import "./style.scss"

const ToastMessage = {
    info: (message, duration) => toast.info(<InfoMessage message={message} />, { hideProgressBar: true, duration: duration ? duration : 5000 }),
    success: (message, duration) => toast.success(<SuccessMessage message={message} />, { hideProgressBar: true, duration: duration ? duration : 5000 }),
    error: (message, duration) => toast.error(<ErrorMessage message={message} />, { hideProgressBar: true, duration: duration ? duration : 5000 })
}

export default ToastMessage